import React from "react";
import classes from './text.module.css';

const TextMarker = (props) => {
    return(
        <p><span>{props.textmarker.span}</span>
            {props.textmarker.content}
        </p>
    )
}

export default TextMarker;